import { getAppNameByAppId, INTEGRATIONS_APPS } from 'integrations-lib/constants/AppIds';
import { EventbriteReconnectionConfig } from './integrations/Eventbrite/EventbriteReconnectionConfig';
import { TrelloReconnectionConfig } from './integrations/Trello/TrelloReconnectionConfig';
import { GoogleSheetsReconnectionConfig } from './integrations/GoogleSheets/GoogleSheetsReconnectionConfig';
import { AIReconnectionConfig } from './integrations/AIIntegrations/AIReconnectionConfig';
import { GoogleSearchConsoleReconnectionConfig } from './integrations/GoogleSearchConsole/GoogleSearchReconnectionConfig';
import { UberconferenceReconnectionConfig } from './integrations/Uberconference/UberconferenceReconnectionConfig';
export const RECONNECTION_CONFIGS = {
  [INTEGRATIONS_APPS.ANTHROPIC]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.COHERE]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.EVENTBRITE]: EventbriteReconnectionConfig,
  [INTEGRATIONS_APPS.GEMINI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.GOOGLE_SEARCH_CONSOLE]: GoogleSearchConsoleReconnectionConfig,
  [INTEGRATIONS_APPS.GOOGLE_SHEETS]: GoogleSheetsReconnectionConfig,
  [INTEGRATIONS_APPS.OPENAI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.TRELLO]: TrelloReconnectionConfig,
  [INTEGRATIONS_APPS.XAI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.UBER_CONFERENCE]: UberconferenceReconnectionConfig
};
export const getReconnectionConfigByAppId = appId => {
  const appName = getAppNameByAppId(appId);
  return RECONNECTION_CONFIGS[appName] || null;
};